export default __webpack_public_path__ + "static/media/redemption-graph.f9230e75.png";